import React, { useMemo } from 'react';
import classnames from 'classnames';

import Show from 'components/Show';
import Step from 'components/Misc/Pagination/Step';
import Page from 'components/Misc/Pagination/Page';

// Pagination creator
// @active: number | current page
// @total: number | total page count
const paginator = (active, total) => {
	// Maximum pages in single view
	const range = 5;

	// Page collection
	const pages = [];

	// Starting page in current view
	const start = Math.min(total + 1 - range, Math.max(1, active - (range / 2 | 0 )));

	// Ending page in current view
	const end = start + range;

	// Create page array starting from 1
	for (let page = (start > 0 ? start : 1); page < end; page++) {
		pages.push(page);
	}

	return pages;
};

// Pagination wrap
// @progress: boolean | collection progress state
// @active: number | current page
// @total: number | collection size
// @onPage: function | onClick handler
const Pagination = ({ progress, active, total, size = 24, onChange, className }) => {
	// Calculate page count
	const count = useMemo(() => Math.ceil(total / size), [total]);

	// Generate current view's pages
	const pages = useMemo(() => paginator(active, count), [active, count]);

	// Toggle classname
	const cls = classnames(
		'flex rounded-lg bg-white dark:bg-neutral-800 overflow-hidden transition-colors',
		className
	);

	// Do not show pagination if not needed
	if (progress || count <= 1) return null;

	return (
		<Show if={!progress && count > 1}>
			<div className="flex justify-start">
				<div className={cls}>
					{/* Step one page backwards */}
					<Step icon="chevron_left" active={active} action="prev" onChange={onChange} />

					{pages.map(idx =>
						<Page key={idx} active={active} number={idx} onChange={onChange} />
					)}

					{/* Step one page forwards */}
					<Step icon="chevron_right" active={active} action="next" onChange={onChange} />
				</div>
			</div>
		</Show>
	);
};

export default Pagination;
